import { useEffect, useState } from 'react';
import { messageAttachmentsRequestParams } from '../../constants';
import styles from './Attachments.module.scss';
import { LinksAttachments } from './FilesAndLinks/LinksAttachments.';
import { ImageAttachments } from './ImageAttachments/ImageAttachments';
import cx from 'classnames';
import { Icon, Text } from 'components';
import { BlockWrapperWithSpinner } from 'components/BlockWrapperWithSpinner/BlockWrapperWithSpinner';
import { selectPatientActionIsLoading } from 'store/patients/selectors';
import { patientsActions } from 'store/patients/slice';
import { useDispatch, useSelector } from 'store/utils';
import { AttachmentsTab, GetMessagesAttachmentsRequestParams } from 'types';

type Props = {
  setDiscussionTab(): void;
};

export const Attachments = ({ setDiscussionTab }: Props) => {
  const [currentTab, setCurrentTab] = useState(AttachmentsTab.IMAGES);
  const getMessageAttachments = useSelector(selectPatientActionIsLoading('getMessagesAttachments'));
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(
        patientsActions.setMessageAttachmentsRequestParams({
          ...(messageAttachmentsRequestParams[AttachmentsTab.IMAGES] as GetMessagesAttachmentsRequestParams),
        }),
      );
    };
  }, []);

  const handleTabChange = (type: AttachmentsTab) => {
    dispatch(
      patientsActions.setMessageAttachmentsRequestParams({
        ...(messageAttachmentsRequestParams[type] as GetMessagesAttachmentsRequestParams),
      }),
    );
    setCurrentTab(type);
  };

  return (
    <div className={styles.container}>
      {getMessageAttachments && <BlockWrapperWithSpinner isLoading={getMessageAttachments} />}
      <div className={styles.header}>
        <Text type="body-big">Attachments</Text>
        <div className={styles.iconWrapper} onClick={setDiscussionTab}>
          <Icon name="Close" />
        </div>
      </div>
      <div className={styles.tabsBlock}>
        <div
          className={cx(styles.tabsWrapper, { [styles.active]: currentTab === AttachmentsTab.IMAGES })}
          onClick={() => handleTabChange(AttachmentsTab.IMAGES)}>
          <Text type="overline">images</Text>
        </div>
        <div
          className={cx(styles.tabsWrapper, { [styles.active]: currentTab === AttachmentsTab.FILES })}
          onClick={() => handleTabChange(AttachmentsTab.FILES)}>
          <Text type="overline">files</Text>
        </div>
        <div
          className={cx(styles.tabsWrapper, { [styles.active]: currentTab === AttachmentsTab.LINKS })}
          onClick={() => handleTabChange(AttachmentsTab.LINKS)}>
          <Text type="overline">links</Text>
        </div>
      </div>
      <div className={styles.attachmentsBlock}>
        {currentTab === AttachmentsTab.IMAGES && <ImageAttachments />}
        {currentTab === AttachmentsTab.FILES && <LinksAttachments type={AttachmentsTab.FILES} />}
        {currentTab === AttachmentsTab.LINKS && <LinksAttachments type={AttachmentsTab.LINKS} />}
      </div>
    </div>
  );
};
